import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import { LoadingButton as Button } from "@mui/lab";
import { IVWPost } from "@/interfaces";
import { useNavigate } from "react-router-dom";
import { formatedBigNumber } from "@/utility";
import numeral from "numeral";
interface IHomeTableProps {
  tradeList?: IVWPost[];
  rowsCount: number;
  isBuy?: boolean;
}

const HomeTable = ({ tradeList, rowsCount, isBuy }: IHomeTableProps) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const isTradeListEmpty = !(tradeList && tradeList.length > 0);

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: "20%" }}>Asset</TableCell>
            <TableCell style={{ width: "20%" }}>Merchant</TableCell>
            <TableCell style={{ width: "20%" }}>Price</TableCell>
            <TableCell style={{ width: "20%" }}>Limits</TableCell>
            <TableCell style={{ width: "20%" }}>Payment methods</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tradeList &&
            tradeList.slice(0, rowsCount).map((row: IVWPost) => (
              <TableRow key={`tbl-${row.post_id}`}>
                <TableCell sx={{ fontWeight: "400 !important" }}>
                  {row.asset_name}
                </TableCell>
                <TableCell sx={{ fontWeight: "400 !important" }}>
                  {row.title}
                </TableCell>
                <TableCell sx={{ fontWeight: "400 !important" }}>
                  {formatedBigNumber(row.price)} {row.currency}
                </TableCell>
                <TableCell sx={{ fontWeight: "400 !important" }}>{`${
                  row.minOrder &&
                  numeral(formatedBigNumber(row.minOrder)).format("0,0.000")
                } - ${
                  row.maxOrder &&
                  numeral(formatedBigNumber(row.maxOrder)).format("0,0.000")
                } ${row.currency}`}</TableCell>
                <TableCell sx={{ fontWeight: "400 !important" }}>
                  {row.payment_name}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>

      {isTradeListEmpty && (
        <Typography
          variant="h3"
          color={theme.colors.noFound}
          mt="82.24px"
          textAlign="center"
        >
          There are no posts yet. Be the first to create one!
        </Typography>
      )}
      <Box width="fit-content" mt="59px" mx="auto">
        <Button
          variant="outlined"
          color="primary"
          size="medium"
          onClick={() => {
            const path = isTradeListEmpty
              ? "/trade/create-post"
              : `/trade?tab=${isBuy ? "buy" : "sell"}`;
            navigate(path);
          }}
        >
          {isTradeListEmpty ? "Create a new post" : "Trade now"}
        </Button>
      </Box>
    </>
  );
};

export default HomeTable;
